import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ContadorTotalPendientesAutorizacionService = async (value) => {
    try {
        const resultado = await instance.Backend.post("/Autorizacion/ContadorTotalPendientesAutorizacion"
        , {usuarioId: value}
        , customConfig);
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { ContadorTotalPendientesAutorizacionService };